import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokolhapurcabs() {



const cardData = {
  keyword: "Mumbai to Kolhapur Cabs",
  heading: "Lotus Cab: Mumbai to Kolhapur Cabs",

  headingDescription:
    "Lotus Cab offers safe, reliable, and affordable Mumbai to Kolhapur cab services for pilgrimage tours, family vacations, corporate travel, and weekend getaways. Kolhapur is known for Mahalaxmi Temple, historical forts, scenic lakes, and rich cultural heritage. Our AC sedans, spacious SUVs, luxury vehicles, and mini buses are perfect for comfortable long-distance travel. We provide transparent per-kilometer pricing with flexible one-way and round-trip packages. All vehicles are GPS-enabled, regularly serviced, and driven by professional chauffeurs trained for highway and ghat routes. With 24/7 booking assistance and punctual doorstep pickup anywhere in Mumbai, Lotus Cab ensures a smooth and stress-free journey to Kolhapur.",

  top: "Top Places to Visit in Kolhapur with Lotus Cab",

  topPlaces: [
    {
      title: "Mahalaxmi Temple",
      description:
        "Mahalaxmi Temple is the most sacred and visited spiritual destination in Kolhapur, attracting devotees from across India. The temple holds immense religious importance and is one of the Shakti Peethas. Many travelers book Mumbai to Kolhapur cabs specifically for temple darshan. Our AC sedan and SUV options ensure relaxed long-distance travel for families and elderly passengers. Professional chauffeurs plan timely arrival to avoid rush hours. Same-day and multi-day packages are available for pilgrimage trips. Lotus Cab makes your spiritual journey peaceful and comfortable."
    },
    {
      title: "Panhala Fort",
      description:
        "Panhala Fort is a historic Maratha fort associated with Chhatrapati Shivaji Maharaj and offers breathtaking views of the Sahyadri hills. The scenic drive to the fort includes mild ghat sections, making SUV options ideal for safe travel. History lovers and weekend travelers often include this fort in their Kolhapur itinerary. Comfortable AC travel ensures relaxed sightseeing after long highway journeys. Our experienced drivers are familiar with hill routes. Flexible waiting time is provided for exploration. Perfect destination for history and photography enthusiasts."
    },
    {
      title: "Rankala Lake",
      description:
        "Rankala Lake is a serene lakeside attraction ideal for evening walks and family relaxation. Visitors enjoy sunset views, boating, and local food stalls around the promenade. After a long drive from Mumbai, this scenic spot provides a refreshing break. Sedan and SUV options ensure comfortable round-trip travel within the city. Families often choose this location for leisure outings. Lotus Cab offers flexible sightseeing packages. A perfect place for peaceful moments with loved ones."
    },
    {
      title: "Jyotiba Temple",
      description:
        "Jyotiba Temple is a popular hilltop pilgrimage site near Kolhapur visited by thousands of devotees. The temple is known for its religious festivals and spiritual significance. SUV vehicles are recommended for comfortable uphill travel. AC vehicles ensure relaxed travel in all seasons. Many pilgrims book round-trip cab packages for darshan and return. Professional drivers ensure safe navigation of hilly roads. Ideal for family pilgrimage tours."
    },
    {
      title: "New Palace Museum",
      description:
        "The New Palace Museum showcases Kolhapur’s royal heritage, architecture, and historical artifacts. Visitors can explore weapon collections, royal memorabilia, and traditional exhibits. It is a great educational and cultural stop for families and students. Comfortable cab travel ensures easy city access. Our chauffeurs provide convenient drop and pickup scheduling. Ideal for half-day sightseeing tours."
    },
    {
      title: "Dajipur Wildlife Sanctuary",
      description:
        "Dajipur Sanctuary is perfect for wildlife enthusiasts and nature lovers. Surrounded by lush greenery and forest landscapes, it offers peaceful natural experiences. SUV cabs are ideal for reaching this scenic destination. Comfortable long-distance travel ensures enjoyable exploration. Group and family tour packages are available. A great destination for weekend adventure trips."
    },
    {
      title: "Shalini Palace",
      description:
        "Shalini Palace is a heritage palace located near Rankala Lake known for its elegant architecture. The palace attracts photographers and luxury travelers. Premium and luxury cab options enhance the royal travel experience. Comfortable AC travel ensures relaxed sightseeing. Ideal for leisure and cultural visits."
    },
    {
      title: "Chandrakant Mandare Museum",
      description:
        "This museum displays artwork and cultural heritage collections related to Kolhapur’s history. It is ideal for art lovers and students. Sedan and SUV options provide smooth city travel. A calm and informative stop during Kolhapur sightseeing tours."
    }
  ],

  services: [
    {
      name: "Mumbai to Kolhapur Cab",
      description:
        "Our Mumbai to Kolhapur cab service provides comfortable and safe long-distance travel for families, corporate travelers, and pilgrims. We offer AC sedans, spacious SUVs, luxury cars, and mini buses depending on your travel needs. All vehicles are well-maintained and sanitized before every trip. Professional chauffeurs ensure smooth highway driving and safe navigation of ghat sections. Transparent per-kilometer pricing is shared before booking confirmation. Flexible pickup from airport, railway station, hotel, or residence is available."
    },
    {
      name: "One Way Cab Mumbai to Kolhapur",
      description:
        "Affordable one-way taxi service from Mumbai to Kolhapur where you only pay for the single-side distance. Ideal for relocation, corporate visits, or temple darshan trips. AC vehicles ensure comfortable long-distance travel even during summer months. Experienced drivers guarantee timely arrival and disciplined highway driving. Transparent fare breakdown eliminates hidden charges. Suitable for both individuals and small families."
    },
    {
      name: "Round Trip Cab Mumbai to Kolhapur",
      description:
        "Flexible round-trip taxi service designed for weekend getaways and multi-day temple tours. Customers can schedule return travel according to their convenience. Our AC vehicles provide comfortable seating for extended journeys. Drivers remain available for local sightseeing during your stay. Transparent billing ensures budget clarity. Ideal for family and group travel."
    },
    {
      name: "SUV Cab Mumbai to Kolhapur",
      description:
        "Spacious SUV taxis are perfect for group travel and extra luggage requirements. These vehicles provide strong highway performance and stability on ghat roads. Comfortable seating ensures relaxed long-distance travel. Ideal for family pilgrimage tours and weekend trips. Professional chauffeurs handle long routes efficiently."
    },
    {
      name: "Luxury Cab Mumbai to Kolhapur",
      description:
        "Premium luxury vehicles available for executive travel, VIP visits, and special occasions. Elegant interiors and comfortable seating enhance long-distance travel experience. Professional chauffeur-driven service ensures punctuality and safety. Ideal for corporate and high-profile clients."
    },
    {
      name: "Mini Bus Cab Mumbai to Kolhapur",
      description:
        "Mini bus service is suitable for large family groups, corporate tours, and pilgrimage trips. Spacious seating ensures comfortable travel for multiple passengers. AC options available for all-season comfort. Professional drivers ensure smooth long-distance journeys."
    },
    {
      name: "Chauffeur Driven Cab Mumbai to Kolhapur",
      description:
        "All cabs are operated by experienced, background-verified chauffeurs trained for interstate and ghat routes. Drivers prioritize safety, punctuality, and courteous service. Highway expertise ensures smooth travel. Customer comfort and security are always maintained."
    },
    {
      name: "Online Cab Booking Mumbai to Kolhapur",
      description:
        "Instant online booking with transparent fare calculation and quick confirmation. 24/7 customer support ensures booking assistance anytime. Flexible scheduling options available for one-way and round-trip travel."
    }
  ],

  tableData: [
    ["Mumbai to Kolhapur Cab", "One Way Cab Mumbai to Kolhapur"],
    ["Round Trip Cab Mumbai to Kolhapur", "AC Cab Mumbai to Kolhapur"],
    ["Sedan Cab Mumbai to Kolhapur", "SUV Cab Mumbai to Kolhapur"],
    ["Luxury Cab Mumbai to Kolhapur", "Family Trip Cab Mumbai to Kolhapur"],
    ["Corporate Cab Mumbai to Kolhapur", "Weekend Trip Cab Mumbai to Kolhapur"],
    ["Mini Bus Cab Mumbai to Kolhapur", "Chauffeur Driven Cab Mumbai to Kolhapur"],
    ["Budget Cab Mumbai to Kolhapur", "Same Day Return Cab Mumbai to Kolhapur"],
    ["Outstation Taxi Mumbai to Kolhapur", "Per Km Rate Cab Mumbai to Kolhapur"],
    ["Best Cab Service Mumbai to Kolhapur", "Group Tour Cab Mumbai to Kolhapur"]
  ],

  whychoose: [
    { WhyChooseheading: "Professional Highway Drivers", WhyChoosedescription: "Experienced chauffeurs trained for long-distance and ghat routes ensuring safe travel." },
    { WhyChooseheading: "Transparent Pricing", WhyChoosedescription: "Clear per-kilometer fare shared before booking with no hidden charges." },
    { WhyChooseheading: "Multiple Vehicle Options", WhyChoosedescription: "Sedan, SUV, luxury cars, and mini buses available for different travel needs." },
    { WhyChooseheading: "Comfortable AC Travel", WhyChoosedescription: "Fully air-conditioned vehicles maintained for smooth long journeys." },
    { WhyChooseheading: "Flexible Booking Options", WhyChoosedescription: "One-way, round-trip, and same-day return packages available." },
    { WhyChooseheading: "24/7 Customer Support", WhyChoosedescription: "Round-the-clock booking and trip assistance provided." },
    { WhyChooseheading: "Sanitized Fleet", WhyChoosedescription: "Regularly cleaned and well-maintained vehicles for hygienic travel." },
    { WhyChooseheading: "Punctual Doorstep Pickup", WhyChoosedescription: "Timely pickup from any location in Mumbai including airport and hotels." }
  ]
};
const faqData = [
  {
    question: "Do you provide one-way cab service from Mumbai to Kolhapur?",
    answer: "Yes, Lotus Cab offers affordable one-way cab service from Mumbai to Kolhapur where you only pay for the single-side distance. This option is ideal for relocation, pilgrimage visits, airport drop connections, or business travel. AC sedans and SUVs are available based on your preference. Transparent fare details are shared before booking confirmation. Professional drivers ensure safe highway travel."
  },
  {
    question: "Is round-trip booking available for Mumbai to Kolhapur?",
    answer: "Yes, we provide flexible round-trip cab packages. Customers can schedule return travel as per their convenience. Our drivers remain available for sightseeing and local travel in Kolhapur if required. Round-trip booking is ideal for weekend family trips and temple darshan tours. Transparent billing ensures no hidden charges."
  },
  {
    question: "What types of vehicles are available?",
    answer: "We offer AC sedans, spacious SUVs, luxury cars, and mini buses. Sedans are ideal for 3–4 passengers, SUVs for families and luggage comfort, and mini buses for large groups. All vehicles are regularly serviced and sanitized before every trip. Luxury options are available for executive and VIP travel."
  },
  {
    question: "Are drivers experienced for long-distance travel?",
    answer: "Yes, all our chauffeurs are background-verified and trained for interstate highway routes. They are experienced in ghat section driving and long-distance travel. Safety, punctuality, and professional behavior are always maintained. Drivers ensure smooth navigation and comfortable travel."
  },
  {
    question: "How is the fare calculated?",
    answer: "Fare is calculated on a transparent per-kilometer basis depending on vehicle type. One-way and round-trip packages have different pricing structures. Toll charges, driver allowance (if applicable), and state permits are clearly explained before booking confirmation. No hidden costs are added later."
  },
  {
    question: "Do you provide same-day return cab service?",
    answer: "Yes, same-day return packages are available for quick temple visits or business trips. This option is suitable for short-duration travel plans. Customers can discuss travel timing in advance for smooth scheduling. Ideal for Mahalaxmi Temple darshan."
  },
  {
    question: "Is online booking available?",
    answer: "Yes, customers can book online with instant confirmation. Our support team is available 24/7 to assist with booking queries. Fare details and vehicle options are shared clearly before confirmation. Booking process is simple and hassle-free."
  },
  {
    question: "Is the vehicle sanitized before travel?",
    answer: "Yes, all vehicles are regularly cleaned and sanitized. We ensure hygienic interiors and well-maintained exteriors. Passenger safety and comfort are our top priorities. AC systems and seats are checked before dispatch."
  },
  {
    question: "Can I book a luxury cab for Mumbai to Kolhapur?",
    answer: "Yes, luxury and premium vehicles are available for executive travel and special occasions. These vehicles provide enhanced comfort, elegant interiors, and professional chauffeur service. Ideal for VIP clients and corporate executives."
  },
  {
    question: "Is 24/7 customer support available?",
    answer: "Yes, our customer support team is available round-the-clock for booking assistance, travel coordination, and emergency support. We ensure smooth communication before, during, and after your journey."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Mehta",
    feedback:
      "We booked a Mumbai to Kolhapur SUV for a family temple trip. The vehicle was clean and very comfortable for long-distance travel. The driver was punctual and extremely polite. He handled the highway and ghat sections smoothly. Pricing was transparent without hidden charges. Overall, it was a stress-free and pleasant journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback:
      "Used round-trip cab service for a weekend visit to Kolhapur. The sedan was well-maintained and AC worked perfectly. Driver arrived on time and remained available for local sightseeing. The booking process was easy and professional. Highly recommended for family trips.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Booked luxury cab for corporate travel from Mumbai to Kolhapur. Very professional chauffeur and comfortable ride experience. Transparent billing and excellent service standards. Ideal for business meetings and executive travel.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Sagar Patil",
    feedback:
      "Affordable one-way cab service with clear per-km pricing. No hidden charges and smooth highway driving. The SUV had ample luggage space. Great experience for relocation travel.",
    rating: 5
  },
  {
    id: 5,
    name: "Ms. Priya Shah",
    feedback:
      "Mini bus service was arranged for our group pilgrimage trip. Seating was comfortable and journey was smooth throughout. Driver was disciplined and cooperative. Excellent coordination and support from booking team.",
    rating: 5
  }
];

































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cabs",
  "image": "https://lotuscab.com/assets/images/mumbai-kolhapur-cab.jpg",
  "description": "Book Mumbai to Kolhapur Cab with Lotus Cab. Choose from AC, sedan, SUV, luxury cabs, Mini Bus, or chauffeur-driven rides for one-way, round trips, family trips, corporate travel, weekend trips, picnic trips, and group tours. Affordable per km rates and same-day return options available.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "680"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "450",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/mumbai-kolhapur-cab"
  }
};



  return (
    <div>
      


<Helmet>
  <title>Mumbai to Kolhapur Cabs | Lotus Cab | Call +91 8767592195</title>
  <meta 
    name="description" 
    content="Book reliable Mumbai to Kolhapur Cab with Lotus Cab. AC, sedan, SUV, luxury cabs, Mini Bus & chauffeur-driven rides for one-way, round trips, family trips, corporate travel, weekend trips & group tours. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Kolhapur Cab, One Way Cab Mumbai to Kolhapur, Round Trip Cab Mumbai to Kolhapur, AC Cab Mumbai to Kolhapur, Sedan Cab Mumbai to Kolhapur, SUV Cab Mumbai to Kolhapur, Luxury Cab Mumbai to Kolhapur, Family Trip Cab Mumbai to Kolhapur, Corporate Cab Mumbai to Kolhapur, Weekend Trip Cab Mumbai to Kolhapur, Online Cab Booking Mumbai to Kolhapur, Mini Bus Cab Mumbai to Kolhapur, Chauffeur Driven Cab Mumbai to Kolhapur, Picnic Trip Cab Mumbai to Kolhapur, Budget Cab Mumbai to Kolhapur, Same Day Return Cab Mumbai to Kolhapur, Outstation Taxi Mumbai to Kolhapur, Per Km Rate Cab Mumbai to Kolhapur, Best Cab Service Mumbai to Kolhapur, Group Tour Cab Mumbai to Kolhapur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokolhapurcabs;